import type { TranslateDictionary } from './en.js';

export const Zh: TranslateDictionary = {
  'Drop a video file here to upload': '将视频文件拖放到此处以上传',
  or: '或',
  'Upload complete!': '上传完成！',
  Retry: '重试',
  'Pausing...': '暂停...',
  Resume: '继续',
  Pause: '暂停',
  'Upload a video': '上传视频',
  'No url or endpoint specified - cannot handle upload': '未指定 URL 或 endpoint - 无法处理上传',
};
